export const environment = {
  backEnd: process.env.REACT_APP_BACK_END_URL ?? "",
  tenor: {
    key: process.env.REACT_APP_TENOR_KEY ?? "",
    client: process.env.REACT_APP_TENOR_CLIENT ?? "",
  },
};
